var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCafeteria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M413.957,160.705h-27.234H125.277c0-38.868,31.504-70.384,70.384-70.384 c1.667,0,3.312,0.076,4.957,0.196c6.449-32.223,34.881-56.494,69-56.494c34.119,0,62.551,24.271,69,56.494 c1.645-0.12,3.29-0.196,4.957-0.196C382.453,90.321,413.957,121.836,413.957,160.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9EBDB"
    },
    d: "M492.936,439.854l-6.405,22.419c-2.473,8.639-11.841,15.709-20.829,15.709H73.532 c-8.987,0-18.356-7.07-20.829-15.709l-6.405-22.419H492.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CD95"
    },
    d: "M26.014,160.705C14.794,176.098,8.17,195.031,8.17,215.5c0,51.407,41.821,93.238,93.238,93.238 h20.033c24.315,57.823,81.506,98.435,148.175,98.435c88.739,0,160.681-71.941,160.681-160.681v-85.787L26.014,160.705 L26.014,160.705z M101.409,276.057c-33.389,0-60.558-27.169-60.558-60.558c0-7.669,1.427-15.142,4.172-22.114h63.913v53.106 c0,10.098,0.937,19.979,2.723,29.565H101.409z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M386.723,226.745v9.536c0,64.572-52.534,117.106-117.106,117.106"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 386.723,
    y1: 150.495,
    x2: 386.723,
    y2: 194.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#700D00"
    },
    d: "M503.83,431.684H35.404c-4.512,0-8.17,3.658-8.17,8.17s3.658,8.17,8.17,8.17h4.731l4.711,16.49 c3.466,12.133,16.066,21.638,28.685,21.638h392.17c12.619,0,25.219-9.505,28.686-21.637l4.712-16.491h4.73 c4.513,0,8.17-3.658,8.17-8.17S508.343,431.684,503.83,431.684z M478.676,460.024c-1.464,5.122-7.648,9.786-12.974,9.786H73.532 c-5.327,0-11.51-4.665-12.973-9.786l-3.429-12.001h424.975L478.676,460.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#700D00"
    },
    d: "M101.406,316.903h14.7c27.51,59.982,87.175,98.439,153.511,98.439 c93.104,0,168.851-75.747,168.851-168.851v-85.792c0-4.512-3.657-8.17-8.17-8.17h-8.597c-4.054-39.036-36.806-69.672-76.735-70.366 c-9.727-33.013-40.375-56.315-75.349-56.315s-65.623,23.303-75.349,56.315c-39.927,0.694-72.681,31.33-76.735,70.366H26.013 c-2.611,0-5.064,1.248-6.603,3.358C6.712,173.312,0,193.924,0,215.496C0,271.412,45.491,316.903,101.406,316.903z M195.655,98.491 c1.3,0,2.695,0.056,4.391,0.173c4.085,0.279,7.773-2.518,8.579-6.547c5.789-28.931,31.439-49.929,60.991-49.929 c29.551,0,55.202,20.997,60.991,49.929c0.806,4.028,4.476,6.824,8.58,6.547c1.695-0.118,3.091-0.173,4.39-0.173 c31.532,0,57.639,23.586,61.655,54.038H134C138.016,122.077,164.124,98.491,195.655,98.491z M30.288,168.871h391.84v77.621 c0,84.094-68.416,152.511-152.511,152.511c-61.569,0-116.775-36.676-140.646-93.437c-1.275-3.032-4.243-5.002-7.532-5.002h-20.032 c-46.906-0.001-85.066-38.161-85.066-85.067C16.34,198.774,21.15,182.739,30.288,168.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#700D00"
    },
    d: "M101.406,284.222h10.253c2.428,0,4.731-1.081,6.283-2.948c1.552-1.867,2.194-4.329,1.75-6.716 c-1.716-9.227-2.586-18.671-2.586-28.067V193.38c0-4.512-3.658-8.17-8.17-8.17H45.025c-3.355,0-6.369,2.051-7.6,5.173 c-3.148,7.984-4.744,16.433-4.744,25.113C32.681,253.392,63.511,284.222,101.406,284.222z M50.896,201.552h49.87v44.941 c0,7.137,0.454,14.298,1.352,21.391h-0.711c-28.886-0.001-52.385-23.501-52.385-52.386 C49.021,210.728,49.651,206.058,50.896,201.552z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafeteria);
export default __webpack_public_path__ + "static/media/cafeteria.56aeb751345989bf41debafd0dd71dec.svg";
export { ForwardRef as ReactComponent };